import VideoModal from "../VideoModal/VideoModal";
import styles from "./StudyMaterialHelpVideoButton.module.css";
import { PlayCircleFilled } from "@material-ui/icons";

const StudyMaterialHelpVideoButton = ({state, stateHandler, title, link}) => {
    console.log(stateHandler)
  return (
    <>
      <PlayCircleFilled
        className={styles.help_video_icon}
        onClick={() => stateHandler(true)}
      />
      {state ? (
        <VideoModal
          videoLink={link}
          title={title}
          clickHandler={() => stateHandler(false)}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default StudyMaterialHelpVideoButton;
